export default __webpack_public_path__ + "static/media/ph.374bb0d6.svg";